import PropTypes from 'prop-types'
import { createContext, useState, useEffect, useContext } from 'react'
import { Space, Spin, Button, notification, message, Popconfirm, Radio, Flex, DatePicker, Image, Upload } from 'antd';
import {
	RadiusBottomleftOutlined,
	RadiusBottomrightOutlined,
	RadiusUpleftOutlined,
	RadiusUprightOutlined,
	LoadingOutlined
} from '@ant-design/icons';

import { SiteContext } from './site';
import { AuthContext } from './AuthProvider';

export const MailboxContext = createContext();
export const MailboxProvider = ({ children }) => {

	// spiner
	const [ spiner, setSpiner ] = useState( 'none' );

	const { isOnline }	= useContext( SiteContext );
	const { getUser }	= useContext( AuthContext );

	// helper: Fetch data definition
	async function fetchData( url, data, method, spinable ) {
		// if( !isOnline ){
// message.error( 'No network!' );
		//	return false;
		// }
		if( spinable )
			setSpiner( 'block' )

		const response = await fetch( url, {
			method: method, // *GET, POST, PUT, DELETE, etc.
			// mode: "no-cors", // no-cors, *cors, same-origin
			headers: {
				"Content-Type": "application/json",
				// session token from login; the backend only returns this user's data
				"Authorization": "Bearer " + ( ( getUser() || {} ).token || '' ),
			},
			...( method == 'POST' && { body: JSON.stringify( data ), } )
		});
		// session missing or expired: log in again
		if( response.status == 401 ){
			localStorage.removeItem( 'user' );
			window.location.replace( '/login' );
			return false;
		}

		if( response.status != 200 ){
			setTimeout( setSpiner, 2000, 'none' );
			const body = await response.json().catch( () => ({}) );
			if( body.message )
				message.error( body.message );
			return false;
		}
		
		if( response.status == 200 ){

			if( method == 'GET' ){
				setTimeout( setSpiner, 2000, 'none' );
				return response.json(); // parses JSON response into native JavaScript objects
			}
			
			if( method == 'POST' ){
				setTimeout( setSpiner, 2000, 'none' );
				return response.json().catch( () => true );
			}

		}
	}

	// Backend url 
	// const base_api_url	= 'http://localhost:8083/'; 	// dev
	// const base_api_url	= 'https://diamta.com/mailboxs/public/index.php/api/'	// prod
	const base_api_url		= 'https://mail.diamta.com/backend/'	// prod 

	// get all mailbox
	const getAllMailboxes = async () => {

		const url		= base_api_url +  'diamta-mail/mailbox/list';
		const data 		= {};
		const method	= 'GET';
		const spinable	= false;
		const mailboxes = await fetchData( url, data, method, spinable );

		return mailboxes ? mailboxes.rows : [];
	}

	// get all domains
	const getAllDomains = async () => {

		const url		= base_api_url + 'diamta-mail/domain/list';
		const data 		= {};
		const method	= 'GET';
		const spinable	= false;
		const domains 	= await fetchData( url, data, method, spinable );

		return domains ? domains.rows : [];
	}

	// is an email address already taken? (null if the check failed)
	const mailboxExists = async ( email ) => {

		const url		= base_api_url + 'diamta-mail/mailbox/exists?email=' + encodeURIComponent( email );
		const rep		= await fetchData( url, {}, 'GET', false );

		return rep ? rep.exists : null;
	}

	// create a mailbox
	const createMailbox = async ( mailboxData ) => {

		const url		= base_api_url + 'diamta-mail/mailbox/create';
		const data 		= mailboxData;
		const method	= 'POST';
		const spinable	= false;
		const rep	 	= await fetchData( url, data, method, spinable );

		return rep;
	}

	// create a mailbox
	const updatePassword = async ( mailboxData ) => {

		const url		= base_api_url + 'diamta-mail/mailbox/update';
		const data 		= mailboxData;
		const method	= 'POST';
		const spinable	= false;
		const rep	 	= await fetchData( url, data, method, spinable );

		return rep;
	}

	// imap login
	const imapLogin = async ( mailbox ) => {
		// the backend gives the password of this mailbox to its owner only
		const credentials = await fetchData( base_api_url + 'diamta-mail/mailbox/webmail-login', { email: mailbox.email }, 'POST', false );
		if( !credentials || !credentials.password )
			return { ok: false };

		const webmailURL = 'https://mail.diamta.com/webmail';
		const output = 'redirect'; // json
		var content = '';
		function params(inputs) {
			let param = [], index;
			for(index in inputs) {
			  param.push(`${encodeURIComponent(index)}=${encodeURIComponent(inputs[index])}`);
			}
			return param.join('&');
		}

		const rep = async () => {
			const rawResponse = await fetch( webmailURL + '/index.php?ExternalLogin', {
				method: 'POST',
				headers: {'Content-Type': "application/x-www-form-urlencoded"},
				body: params({Email: credentials.email, Password: credentials.password, Output: output})
			});
			if( output == 'json' )
				content = await rawResponse.json();
			else
				content = await rawResponse
			return content;
		}
		
		return await rep();
	}

	return (	
	
		<MailboxContext.Provider 
			value={{
				getAllMailboxes,
				getAllDomains,
				mailboxExists,
				createMailbox,
				updatePassword,
				imapLogin
			}}
		>
		
			<Space
				style={{ display: spiner }}
			>
				<Spin
					indicator={
						<LoadingOutlined
							style={{
									display:		spiner,
									fontSize: 		100,
									color: 			'#fcb800'
								}}
							spin
						/>
					}
					fullscreen
					tip		= "Loading" 
					size	= "large"
				/>
			
			</Space>

		{children}

		</MailboxContext.Provider>

	);
	
	
	
};

MailboxProvider.propTypes = {
	children: PropTypes.node.isRequired,
};